
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/resources/calculators/simple",
      function () {
        return require("private-next-pages/resources/calculators/simple.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/resources/calculators/simple"])
      });
    }
  